import { useCallback } from "react";

const useFormatForInput = () =>
  useCallback((dateStr) => {
    // If only date is given like "28/8/2025"
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split("/").map(Number);
      return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    }

    // If date and time is given like "20/08/2025, 04:55 pm"
    if (/^\d{1,2}\/\d{1,2}\/\d{4},\s\d{1,2}:\d{2}\s?(am|pm)$/i.test(dateStr)) {
      const [d, t] = dateStr.split(", ");
      const [day, month, year] = d.split("/").map(Number);
      let [time, modifier] = t.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier.toLowerCase() === "pm" && hours < 12) hours += 12;
      if (modifier.toLowerCase() === "am" && hours === 12) hours = 0;

      return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T${String(hours).padStart(2, "0")}:${minutes}`;
    }

    return ""; // fallback if not matching
  }, []);


export default useFormatForInput;
